import { jsx as _jsx } from "react/jsx-runtime";
import { useSidebarStore } from "../../lib/sidebarStore";
import { Icon } from "../primitives/Icon";
/**
 * Hamburger button that toggles the shared Sidebar open/closed. Lives in the
 * topbar so the sidebar can collapse to zero width — the user reclaims the
 * full content area instead of staring at a redundant icon rail. Reads the
 * single source of truth in `useSidebarStore`, so any number of toggles can
 * coexist (topbar, future shortcut, etc.).
 */
export function SidebarToggle() {
    const expanded = useSidebarStore((s) => s.expanded);
    const toggle = useSidebarStore((s) => s.toggle);
    return (_jsx("button", { type: "button", className: "sidebar-toggle", onClick: toggle, "aria-label": expanded ? "Collapse sidebar" : "Expand sidebar", "aria-expanded": expanded, "aria-controls": "sidebar", title: expanded ? "Collapse sidebar" : "Expand sidebar", children: _jsx(Icon, { name: expanded ? "panel-left-close" : "menu", size: "md" }) }));
}
//# sourceMappingURL=SidebarToggle.js.map